var Block = require('models/block');

var BlocksCollection = Chaplin.Collection.extend({
  model: Block

});

module.exports = BlocksCollection;